// SecurityHubPage — 2FA, sessions, activity log, notification prefs

import { HubLayout } from './HubLayout';

export function SecurityHubPage() {
  return (
    <HubLayout
      title="Security & Privacy"
      testIdRoot="hub-security"
      hero={{
        title: 'Stay safe',
        subtitle: '2FA, sessions, and account activity',
        emoji: '🔐',
        gradient: 'linear-gradient(135deg, #FF3B30 0%, #B82B22 100%)',
        stats: [
          { label: '2FA',      value: '✓ On',  sub: 'authenticator', color: '#34C759' },
          { label: 'Sessions', value: '3',     sub: 'active devices' },
          { label: 'Alerts',   value: '2',     sub: 'unread', color: '#FFD60A' },
        ],
      }}
      quickActions={[
        { to: '/portal/2fa-setup', label: 'Setup 2FA',  icon: '🔑', testId: 'hub-security-qa-2fa' },
        { to: '/portal/security',  label: 'Sessions',   icon: '📱', testId: 'hub-security-qa-sessions' },
        { to: '/portal/activity',  label: 'Activity',   icon: '📋', testId: 'hub-security-qa-activity' },
      ]}
      sections={[
        {
          title: 'Authentication',
          items: [
            { to: '/portal/2fa-setup',            icon: '🔐', iconBg: 'linear-gradient(135deg, #34C759 0%, #248A3D 100%)', label: 'Two-factor authentication', sub: 'Authenticator app · enabled', badge: { text: 'Active', color: 'white', bg: '#34C759' } },
            { to: '/portal/security',             icon: '🛡️', iconBg: 'linear-gradient(135deg, #FF3B30 0%, #B82B22 100%)', label: 'Security center',         sub: 'Sessions, login alerts' },
          ],
        },
        {
          title: 'Activity & Alerts',
          items: [
            { to: '/portal/activity',             icon: '📋', iconBg: 'linear-gradient(135deg, #8E8E93 0%, #48484A 100%)', label: 'Activity log',         sub: 'All account actions · immutable' },
            { to: '/portal/notifications-settings', icon: '🔔', iconBg: 'linear-gradient(135deg, #FF9500 0%, #C93400 100%)', label: 'Notification preferences', sub: 'Push · Email · SMS · In-app' },
          ],
        },
      ]}
      footerNote="Account changes require re-authentication. All security events are logged."
    />
  );
}
